import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CreateInvitationDTO} from '../models/dbdtos.interface';
import {Invitacion} from '../models/dbresponses.interface';
import {ViaCheckApiQueryService} from './via-check-api-query.service';

@Injectable({
  providedIn: 'root',
})
export class InvitationsQuerysService extends ViaCheckApiQueryService {
  public postInvitation(
    invitacion: CreateInvitationDTO
  ): Observable<Invitacion> {
    const subdomain = 'invitaciones';
    return this.networkRequest('post', subdomain, invitacion);
  }

  public getInvitation(id: number): Observable<Invitacion> {
    const subdomain = `invitaciones/${id}`;
    return this.networkRequest('get', subdomain);
  }

  public getInvitationByPerson(id: number): Observable<Invitacion[]> {
    const subdomain = `personas/${id}/invitaciones`;
    return this.networkRequest('get', subdomain);
  }

  public deleteInvitation(invitationID: number): Observable<any> {
    const subdomain = `invitaciones/${invitationID}`;
    return this.networkRequest('delete', subdomain);
  }
}
